let lastScrollY = 0;
let ticking = false;
let scrollTimeout;
let header = document.querySelector('.jsSiteHeader');
let urgentMessage = document.querySelector('.jsUrgentMessage');
let headerHeight = header ? header.clientHeight : 0;
let urgentMessageHeight = urgentMessage ? urgentMessage.clientHeight : 0;

// Thresholds for stability
const TOP_THRESHOLD = 130;           // Small base threshold (px)
let HYSTERESIS = 0;                // Will be set dynamically

function updateMeasurements()
{
	if (header)
	{
		headerHeight = header.clientHeight;
		// Set hysteresis to slightly more than the tallest expected header
		/* HYSTERESIS = Math.ceil(headerHeight * 1.05) + 10;  // 5% buffer + safety margin */
		HYSTERESIS = headerHeight;  // 5% buffer + safety margin
	}
	if (urgentMessage) urgentMessageHeight = urgentMessage.clientHeight;
}

function goingUp()
{
	document.documentElement.classList.add('going-up');
	document.documentElement.classList.remove('going-down');
}

function goingDown()
{
	document.documentElement.classList.add('going-down');
	document.documentElement.classList.remove('going-up');
}

let directionLockUntil = 0;  // timestamp when we can next change direction

function handleScroll()
{
	const currentScrollY = Math.max(0, window.scrollY || document.documentElement.scrollTop);

	// is-scrolling class
	document.documentElement.classList.add('is-scrolling');
	clearTimeout(scrollTimeout);
	scrollTimeout = setTimeout(() =>
	{
		document.documentElement.classList.remove('is-scrolling');
	}, 100);

	const now = Date.now();
	const isCurrentlyAtTop = document.documentElement.classList.contains('at-top');
	const previousScrollY = lastScrollY;

	// iOS bounce / near-top with dynamic hysteresis
	if (isCurrentlyAtTop)
	{
		if (currentScrollY > TOP_THRESHOLD + HYSTERESIS)
		{
			document.documentElement.classList.remove('at-top');
			goingDown();
			directionLockUntil = now + 120;  // Lock after leaving top
		} else
		{
			goingUp();
		}
	} else
	{
		if (currentScrollY < TOP_THRESHOLD)
		{
			document.documentElement.classList.add('at-top');
			goingUp();
			directionLockUntil = now + 80;
		} else if (now > directionLockUntil)
		{
			const delta = currentScrollY - previousScrollY;
			const absDelta = Math.abs(delta);

			if (absDelta > 8 && absDelta < 100)
			{
				if (delta > 0)
				{
					goingDown();
				} else
				{
					goingUp();
				}
			}
		}
	}

	lastScrollY = currentScrollY;
	ticking = false;

	// After logo swap / class change that affects header height
	// updateMeasurements();
}

// Throttled scroll handler using RAF
function onScroll()
{
	if (!ticking)
	{
		requestAnimationFrame(handleScroll);
		ticking = true;
	}
}

// Event listeners
window.addEventListener('scroll', onScroll, { passive: true });
window.addEventListener('resize', () =>
{
	updateMeasurements();
}, { passive: true });

// Focus support
const headerLinks = document.querySelectorAll('.jsSiteHeader a, .jsSiteHeader button, .jsSiteHeader input');
headerLinks.forEach(link =>
{
	link.addEventListener('focus', goingUp);
});

// Initial call + measurements
updateMeasurements();
handleScroll();  // run once on load